/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                jQuery('.list-group.gallery-panel a.list-group-item-success').click(function (event) {
                    //event.preventDefault();
                    if (jQuery(this).children('span').hasClass('glyphicon-menu-right')) {
                        jQuery(this).children('span').removeClass('glyphicon-menu-right');
                        jQuery(this).children('span').addClass('glyphicon-menu-down');
                    } else
                    {
                        jQuery(this).children('span').removeClass('glyphicon-menu-down');
                        jQuery(this).children('span').addClass('glyphicon-menu-right');
                    }
                });

                /*Scroll to timing section on click of clock from header*/
                if (jQuery('body').hasClass('home')) {
                    jQuery(".nav_item2 a").click(function (e) {
                        e.preventDefault();
                        jQuery('html, body').animate({
                            scrollTop: jQuery("#thonex-timing").offset().top - 50
                        }, 1000);
                    });
                }
                /* slider initialize*/

                jQuery("#actualite_wrapper_slider").owlCarousel({
                    navigation: false, // Show next and prev buttons
                    slideSpeed: 300,
                    paginationSpeed: 400,
                    singleItem: true
                });

                jQuery("#home_agenda_slider").owlCarousel({
                    navigation: false, // Show next and prev buttons
                    slideSpeed: 300,
                    paginationSpeed: 400,
                    singleItem: true
                });

                /* mobile menu */

                /* close menu */
                jQuery(".shiftnav-submenu-activation-close").click(function () {
                    jQuery(this).hide();
                    jQuery(this).siblings(".shiftnav-submenu-activation-open").show();
                    jQuery(this).siblings("ul.sub-menu").hide();
                });

                /* open menu */
                jQuery(".shiftnav-submenu-activation-open").click(function () {
                    jQuery(this).hide();
                    jQuery(this).siblings(".shiftnav-submenu-activation-close").show();
                    jQuery(this).siblings("ul.sub-menu").show();
                });

                /* menu border radius for dektop */
                jQuery(".access-direct-column").each(function () {
                    jQuery(this).children().first().children().first().children().first().children().first().after("<div class='round_corner'></div>");
                });

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
